<template>
    <div>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="listing-header columns">
                <div class="group-search column">
                    <search-bar :onSearch="debouncedOnSearch" />
                </div>

                <div class="header-buttons column mr-3 is-2">
                    <button
                        v-if="permissao.update"
                        @click="save()"
                        :disabled="isSaving"
                        class="save-btn is-100 mt-3"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>

            <div class="checkbox-group column">
                <div v-if="segmentoSelecionado.length > 0" class="is-flex-column">
                    <span class="subtitle">{{ $t('selecionados') }}:</span>
                    <div class="columns is-flex-wrap">
                        <div
                            v-for="segmento in segmentoSelecionado"
                            :key="`selected-${segmento.id}`"
                            class="column is-2"
                        >
                            <b-checkbox v-model="segmentoSelecionado" :native-value="segmento">
                                {{ segmento.descricao }}
                            </b-checkbox>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="is-flex-column">
                    <div class="is-flex is-flex-vcenter">
                        <span class="subtitle m-0">{{ $t('opcoes') }}:</span>
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="$t('aviso-multiplas-relacoes-n', { n: $t('segmento') })"
                        />
                    </div>

                    <empty-table-message v-if="isEmpty" />
                    <div class="columns is-flex-wrap">
                        <div v-for="segmento in segmentos" :key="segmento.id" class="column is-2">
                            <b-checkbox v-model="segmentoSelecionado" :native-value="segmento">
                                {{ segmento.descricao }}
                            </b-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import B2BSegmentoService from '@/services/b2b/B2BSegmentoService';
import B2BClienteSegmentoService from '@/services/b2b/B2BClienteSegmentoService';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            permissao: {},
            isLoading: false,
            isSaving: false,
            segmentos: [],
            segmentoSelecionado: [],
            debouncedOnSearch: null,
            b2bSegmentoService: new B2BSegmentoService(this.$http, this.$router),
            service: new B2BClienteSegmentoService(this.$http, this.$router),
            isEmpty: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('b2b', 'b2b-parametrizacoes-edit');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'dados-iniciais' },
            });
        } else {
            this.carregarDados();
            this.carregarClienteSegmento();
        }

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        onSearch(value) {
            this.carregarDados(this.removeToSearch(value));
        },
        carregarDados(searchQuery) {
            this.isLoading = true;

            this.b2bSegmentoService
                .findAll(searchQuery)
                .then(({ content }) => {
                    this.segmentos = content;

                    this.isEmpty = content.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load-segmento');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarClienteSegmento() {
            this.service
                .findAll()
                .then(({ content }) => {
                    this.segmentoSelecionado = content;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                });
        },
        save() {
            this.service
                .insertBulk(this.segmentoSelecionado)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-save-segmento-sucesso');
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-group {
    padding: 0.5em 0.75em;
}

.group-search {
    .search-wrapper {
        border-radius: 5px;
    }
}
.checkbox {
    font-size: 14px;
    padding: 8px 0;
}

.subtitle {
    color: var(--primary-color);
}
</style>
